import { request } from './request';

const objectToUrlParams = (obj: Record<string, unknown> | undefined): URLSearchParams => {
	const params = new URLSearchParams();

	if (!obj) return params;

	Object.entries(obj).forEach(([key, value]) => {
		if (value !== undefined && value !== null) {
			params.append(key, String(value));
		}
	});

	return params;
};

export const getFetch = async <T>(
	token: string | null | undefined,
	url: string,
	params?: Record<string, unknown>
): Promise<T> => {
	const query = objectToUrlParams(params).toString();

	return request<T>(query ? `${url}?${query}` : url, { method: 'GET', token });
};
